// src/services/apiMiddleware.js
import axios from "axios";

// Create axios instance with base config
const apiMiddleware = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || "http://127.0.0.1:8000") + "/api", // your API base URL
  timeout: 300000, // optional timeout
});

// Request interceptor to add auth token if exists
apiMiddleware.interceptors.request.use(
  (config) => {
    // Ensure API returns JSON errors (prevents redirects/HTML responses on 401)
    config.headers.Accept = "application/json";

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Only set Content-Type for JSON requests, not for FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    } else {
      // For FormData, let the browser set the correct Content-Type with boundary
      delete config.headers["Content-Type"];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for global error handling
apiMiddleware.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can handle specific error statuses globally here
    if (error.response) {
 
      // Only handle 401 for non-login/register routes
      if (error.response.status === 401 && 
          !error.config.url.includes('/login') && 
          !error.config.url.includes('/register')) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiMiddleware;
